<template>
  <div>
    <Form
      ref="form"
      class="RealisationDetail PageWrapper DetailGrid"
      @error="handleValidationError"
      @submit="handleSubmit"
    >
      <RealisationHeader
        :feedback="feedback"
        :feedback-message="feedbackMessage"
        :step="currentStep"
        :record-step="step"
        :record="record"
      >
        <b-button
          variant="outline-light"
          class="ml-3"
          size="sm"
          type="submit"
          @click.prevent.stop="handlePrevious"
        >
          Vorige stap
        </b-button>

        <template v-if="! locked">
          <b-button
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
          >
            Opslaan
          </b-button>
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || disableNextBtn"
            @click.prevent.stop="handleComplete"
          >
            Afronden
          </b-button>
        </template>
      </RealisationHeader>

      <RealisationSidebar
        :uuid="uuid"
        :disabled="disabled || locked"
      />

      <div class="DetailGrid__col1">
        <!-- <h3>Opleveringsinformatie</h3>
        <FinalDelivery :values="values" :disabled="locked || disabled" /> -->
        <h3>Laadpaal ID's</h3>
        <ChargerIds
          :values="chargerIds"
          :disabled="locked || disabled"
        />
      </div>
      <div class="DetailGrid__col2">
        <h3>SAT documentatie</h3>
        <FilesManager
          :uuid="uuid"
          :disabled="disabled"
          :locked="locked"
          :wide="true"
          category="deliverydocumentation"
          view="list"
          linklabel="download"
        />
        <p v-if="locked && ! record.hasFileOfCategory({ category: 'deliverydocumentation' })">
          Er is geen opleveringsdocumentatie beschikbaar
        </p>
      </div>

      <div class="DetailGrid__col2">
        <!-- <h3>Maillijst</h3>
        <p>Status: Todo</p>
        <b-button>
          Stuur email
        </b-button> -->
      </div>

      <RealisationFooter
        :feedback="feedback"
        :feedback-message="feedbackMessage"
      >
        <b-button
          variant="outline-light"
          class="ml-3"
          size="sm"
          type="submit"
          :disabled="disabled"
          @click.prevent.stop="handlePrevious"
        >
          Vorige stap
        </b-button>

        <template v-if="! locked">
          <b-button
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
          >
            Opslaan
          </b-button>
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || disableNextBtn"
            @click.prevent.stop="handleComplete"
          >
            Afronden
          </b-button>
        </template>
        <template v-else-if="mayEdit">
          <b-button
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
            @click.prevent.stop="handleStartCorrection"
          >
            Corrigeren
          </b-button>
        </template>
      </RealisationFooter>
    </Form>
    <Comments :uuid="uuid" :version="version" @sync="handleSync" />
  </div>
</template>

<script>

import RealisationHeader from '@/components/realisation/RealisationHeader'
import RealisationFooter from '@/components/realisation/RealisationFooter'
import RealisationSidebar from '@/components/realisation/RealisationSidebar'

import Form from '@/components/form/Form'

// import FinalDelivery from '@/components/definitions/FinalDelivery'
import ChargerIds from '@/components/definitions/ChargerIds'
// import FileUpload from '@/components/FileUpload'
import FilesManager from '@/components/files/FilesManager.vue'

import Comments from '@/components/Comments'

import BaseRealisationStep from '@/views/BaseRealisationStep'

export default {
  name: 'RealisationStep8',
  components: {
    RealisationSidebar, RealisationHeader, RealisationFooter,
    Form, 
    // FileUpload, 
    Comments,
    // FinalDelivery,
    ChargerIds,
    FilesManager
  },
  mixins: [BaseRealisationStep],
  data() {
    return {
      currentStep: '8',
    }
  },
  computed: {
    minDeliveryDocumentationDocsId() {
      try {
        return this.minIdByDocType({ doctype: 'DeliveryDocumentation' })
        // return this.record.values.Docs.DeliveryDocumentation.reduce((result, id) => Math.max(result,id), 0)
      } catch (e) {
        return 0
      }
    },
    // Apply data mapping
    chargerIds() {
      try {
        return {
          ChargerIds: {
            ChargerIds: this.values.ChargerIds.ChargerIds.map(identifier => {
              return {
                identifier,
              }
            }),
          },
        }
      } catch (e) {
        return this.values
      }
    },
  },
  created() {
    // console.log("step 8")
    // console.log(this.record)
    // console.log(this.values)
  },
  methods: {
    handleComplete: async function() {
      this.$refs.form.validate()
      if (! this.$refs.form.isValid()) {
        this.handleValidationError()
        return
      }

      this.goingToNextStep = true
      let success = await this.handleSubmit()
      this.goingToNextStep = false

      if (success) {
        this.locked = true
      }
    },
    prepData({ data }) {

      // data.Docs = {
      //   DeliveryDocumentation: this.prepDocData({ doctype: 'DeliveryDocumentation' }),
      // }
      if (data.ChargerIds) {
        data.ChargerIds = data.ChargerIds.map(entry => entry.Identifier).filter(entry => ![null, undefined].includes(entry))
      } else {
        data.ChargerIds = []
      }

      return data
    },
    prepStatus() { // { data }
      let status = {
        uuid: this.currentStepData?.uuid,
      }

      // Going to the next step?
      if (this.goingToNextStep && ! this.locked) {

        status = {
          uuid: this.currentStepData?.uuid,
          label: 'Afgerond',
          completed: true,
        }
      }
      return status
    },
    isValidData({ data }) {
      if (this.goingToNextStep) {
        try {
          if (
            // data.FinalDelivery.LocationReadyDate === '' ||
            // data.FinalDelivery.ChargerReadyDate === '' ||
            // data.FinalDelivery.BatchCode === '' ||
            data.ChargerIds.length < 1
          ) {
            throw new Error('')
          }
        } catch (e) {
          this.disabled = false
          this.feedback = 'danger'
          this.feedbackMessage = 'Afronden is niet mogelijk zonder minimaal 1 laadpaal ID in te vullen.'
          return false
        }
      }
      return true
    },
  },
}
</script>
